<template>
	<div>
		<div style="text-align: left;">
			<el-button size="small" type="primary" icon="el-icon-plus" @click="addCtrl">新增</el-button>
		</div>
		<div class="comStyle">
			 <el-table :header-cell-style="{background:'#eee',color:'#606266'}"
			    :data="tableData"
				@selection-change="handleSelectionChange"
				:row-class-name="tableRowClassName"
			
				size="mini"
			    style="width: 100%">
				<el-table-column
				        type="selection"
				        width="55">
				</el-table-column>			    
			    
			    <el-table-column
			      label="ID" width="50px"
			      prop="id">
			    </el-table-column>
			    <el-table-column
			      label="命令名称" width="250px"
			      prop="orderName">
			    </el-table-column>
			    <el-table-column 
			      label="命令内容"
			      prop="orderContent">
			    </el-table-column>	
				<el-table-column
				  label="命令协议"
				  prop="agreement" width="80px">
				</el-table-column>	
				
				
			  </el-table>			  
			  <el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					v-show="play"
					:current-page="currentPage"
					:page-sizes="[10, 20, 30, 40]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalD">
			  </el-pagination>
			  
			</div>
			<div style="text-align: left;">
				<el-button size="small" type="danger" icon="el-icon-check" @click="updateCtrl"
				:disabled="multipleSelection.length==0">编辑</el-button>
				<el-button size="small" type="danger" icon="el-icon-minus" @click="deleteCtrl"
				:disabled="multipleSelection.length==0">删除</el-button>
				<!-- <el-button @click="drawer = true" type="primary" style="margin-left: 16px;">
				  点我打开
				</el-button> -->
			</div>
			
					     
			
			
			<el-drawer
			  :title="namelg"
			  :visible.sync="dialogVisible"
			  direction="rtl"
			  :before-close="handleClose" 
			  size="30%"
			  >
			  
			  <el-form :rules="rules" inline
				  ref='updatePos' label-position="left" 
				  :model="updatePos" class="comDia" size="mini" >
				  
				  <el-form-item label="ID" >
				  <el-input class="updatePosInput-status" size="small" v-model="updatePos.id" 
				  :disabled="true" ></el-input>
				  </el-form-item>
				  
				  <el-form-item label="命令名称" prop="orderName">
				  <el-input autofocus="off" class="updatePosInput-status" size="small" v-model="updatePos.orderName"></el-input>
				  </el-form-item>
				  <el-form-item label="命令内容" prop="orderContent">
				  <el-input type="textarea"  :rows="4" autofocus="off" class="updatePosInput-status" 
				  size="small" v-model="updatePos.orderContent"></el-input>
				  </el-form-item>
				  <el-form-item label="命令协议" prop="agreement">
				  <el-input   autofocus="off" class="updatePosInput-status" 
				  size="small" v-model="updatePos.agreement"></el-input>					   
				  </el-select>
				  </el-form-item>
				 <br />
				  <el-form-item>
				  <el-button size="small" @click="dialogVisible = false">取 消</el-button>
				  <el-button size="small" type="primary" @click="doUpdate(updatePos)">确 定</el-button>
				  </el-form-item>
			   </el-form>
			  
			</el-drawer>
			
	</div>
</template>

<script>
	export default {
		name: "SysCtr",	
		data() {
		  return {
			namelg:"更新反控配置",
			paramSelect:[],
		    tableData: [],
			dialogVisible: false,
			inforVisible:false,
			// showf:true,
			// drawer:false,
			multipleSelection: [],
			inforSelection:{},
			inforSize:0,
			
			currentPage:1 ,
			play:true,
			pageSize:10,
			totalD: 0,			
			updatePos: {
				id:null,
				orderName:null,
				orderContent:null,
				agreement:null,
				
			},
			rules:{
				orderName: [
					{ required: true,message: '命令名称不能为空！', trigger: 'blur' }
				],
				orderContent: [
					{ required: true,message: '命令内容不能为空！', trigger: 'blur' }
				],
				agreement: [
					{ required: true,message: '命令协议不能为空！', trigger: 'blur' }
				],
								
			},
			
			
		  };
		},
		mounted() {
			this.initLoad();
		},
		methods: {
			
			
			faseKey(item){
				if(item.inforF){
					this.$data.inforSelection[item.value]=item;
					this.$data.inforSize=this.$data.inforSize+1;
				}
				else{
					delete this.$data.inforSelection[item.value];
					this.$data.inforSize=this.$data.inforSize-1;
				}
				console.log(this.$data.inforSelection.valueOf());
			},			
			handleSizeChange(val) {
				
				console.log(`每页 ${val} 条`);
				this.$data.pageSize=val;
				this.initLoad();
				this.$data.inforSelection={};
				this.$data.inforSize=0;
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				
				this.$data.currentPage=val;
				this.initLoad();
				this.$data.inforSelection={};
				this.$data.inforSize=0;
			},			
			handleClose:function(done){
				done();
			},
			formatBoolean: function (row, column, cellValue) {
				var ret = ''  //你想在页面展示的值
				if (cellValue) {
					ret = "是"  //根据自己的需求设定
				} else {
					ret = "否"
				}
				return ret;
			},		
			tableRowClassName({row, rowIndex}) {
				
				if ((rowIndex%2) == 1) {
				  return 'success-row';
				} 
				return '';
			  },
			addCtrl(){
				this.namelg='保存反控配置'
				this.updatePos.id=null;
				this.updatePos.orderName=null;
				this.updatePos.orderContent=null;
				this.updatePos.agreement=null;
				this.dialogVisible=true;
			
			},
			
			doUpdate(){
				this.$refs.updatePos.validate((valid) => {
					
					console.log(this.updatePos.haveForecast);
					console.log(this.updatePos.dianName);					
					if (valid) {
						if(this.updatePos.id==null){
							this.$confirm('此操作新建一条记录', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
								this.updatePos.id=null;
							    this.postRequest("/system/config/sysctrl",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
							    this.$message({
							        type: 'info',
							        message: '已取消保存',
									
							    });
								//this.dialogVisible=false;
							});
						}else{
							this.$confirm('此操作修改ID=【' + this.updatePos.id + '】的记录?', '提示', {
							        confirmButtonText: '确定',
							        cancelButtonText: '取消',
							        type: 'warning',
							}).then(() => {
							    
							    this.postRequest("/system/config/sysctrl",this.updatePos).then(resp => {
							        if (resp) {
							            this.initLoad();
										
										this.dialogVisible=false;
							        }
							    })
							}).catch(() => {
								//this.dialogVisible=false;
							    this.$message({
							        type: 'info',
							        message: '已取消修改'
							    });
								
							});
						}
					} else {
						console.log('请输入所有字段！');
						return false;
					}
				})
				
				
			},
			updateCtrl(){
				if(this.multipleSelection.length!=1){
					this.$message({
					    type: 'warning',
					    message: '请选择单条数据编辑！'
					});
				}else{
					
					this.namelg='更新反控配置'
					this.multipleSelection.forEach(item => {
						this.updatePos.id=item.id;
						this.updatePos.orderName=item.orderName;
						this.updatePos.orderContent=item.orderContent;
						this.updatePos.agreement=item.agreement;
						
					});
					this.dialogVisible=true;
					
					
				}
			},
			deleteCtrl(){
				this.$confirm('此操作将永久删除【' + this.multipleSelection.length + '】条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = '?';
                    this.multipleSelection.forEach(item => {
                        ids += 'ids=' + item.id + '&';
                    })
                    this.deleteRequest("/system/config/sysctrl" + ids).then(resp => {
                        if (resp) {
                            this.initLoad();
							
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
			initLoad(){
				this.$data.updatePos.limit=this.$data.pageSize;
				this.$data.updatePos.start=(this.$data.currentPage-1)*this.$data.pageSize;
				this.postRequest("/system/config/gsysctrl",this.$data.updatePos).then(resp => {
				    //this.loading = false;
				    this.$data.totalD=resp.totalD;
					this.$data.tableData = resp.ctrlData;
					
				})
			},
			handleSelectionChange(val) {
				
				this.multipleSelection = val;
			},
		  arraySpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (rowIndex % 2 === 0) {
		      if (columnIndex === 0) {
		        return [1, 2];
		      } else if (columnIndex === 1) {
		        return [0, 0];
		      }
		    }
		  },
				
		  objectSpanMethod({ row, column, rowIndex, columnIndex }) {
		    if (columnIndex === 0) {
		      if (rowIndex % 2 === 0) {
		        return {
		          rowspan: 2,
		          colspan: 1
		        };
		      } else {
		        return {
		          rowspan: 0,
		          colspan: 0
		        };
		      }
		    }
		  }
		}
	}
</script>

<style>
	.comStyle{
		margin-bottom: 8px
	}
	.updatePosInput-status {
	    width: 200px;
	    margin-right: 10px;
	}
	.comDia{
		font-size: 0;
		align-items: 2000px;
	}
	.comDia label{
		width: 80px;
		color: #99a9bf;
		
	}
	.el-table .success-row {
	    background: #f0f9eb;
	  }
	.input-boxp{
		width: 110px; 
		margin-right: -27px;
	}
	.demo-table-expand-infor {
	   font-size: 0;
	
	 }
	 .demo-table-expand-infor label {
	   width: 80px;
	   color: #99a9bf;
	 }
	 .el-form-it-infor {
	   margin-right: -100px;
	   margin-bottom: 0;
	   margin-left: 0;
	   
	 		
	 }  
</style>

